


















































import Vue from 'vue'
import {api} from '../singleton'
export default Vue.extend({
  components: {
  },
  data: () => ({
  }),
  computed: {
    isLoggedIn (): boolean { return this.$state.auth.isLoggedIn },
  },
  methods: {
    logout () {
      api.reqMan.logout().then((r) => {
        this.$s.auth.mutations.assignLoginState(null)
        this.$router.push({name: 'login'})
      })
    }
  }
})
